export class TherapistClassificationInfoResponseModel {
  therapistClassificationInfoId: number;
  therapistId: number;
  classificationTypeId: number;
 isActive: boolean;
  modifiedByUserInfoId : number;
 dateTimeCreated : Date;
  dateTimeLastModified : Date;
  classificationTypeName: string;
 crmClassificationDisplayName: string;
 selected?:boolean;

}
